export default __webpack_public_path__ + "static/media/blobPink.739a09b7.svg";